import JwtSignInForm from '@auth/services/jwt/components/JwtSignInForm';

function jwtSignInTab() {
	return (
		<div className="w-full">
			<JwtSignInForm />
		</div>
	);
}

export default jwtSignInTab;
